export enum AiTutorSessionMessageRole {
    /** 유저 질문 */
    User = 0,
    /** AI 답변 */
    Assistant = 1,
    /** 시스템 메시지 (안내, 안내문구 등) */
    System = 2,
}

export enum AiTutorAssistantSessionMessageStatus {
    InProgress = 0,
    Completed = 1,
    Failed = 2,
}

export enum AiTutorSessionMessageContentType {
    Text = 0,
    Image = 1,
}

export enum AiTutorAssistantSessionMessageEvaluation {
    Good = 0,
    Bad = 1,
}

export enum AiTutorSessionSourceType {
    Study = 0,
    StudyReview = 1,
    Challenge = 2,
    ConceptEnhancement = 3,
}
